import { Locale } from './enums';

export type LocalizedString = Partial<Record<Locale, string>>;

export function fillLocalizedString(localizedString: LocalizedString = {}): LocalizedString {
    return Object.fromEntries(
        Object.values(Locale).map(locale => [locale, localizedString[locale] ?? ''])
    ) as LocalizedString;
}
